export default "__VITE_ASSET__L_O119ku__"